"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetProfileSectionsData = void 0;
class GetProfileSectionsData {
    constructor(userRepository) {
        this.userRepository = userRepository;
    }
    execute(callback) {
        return this.userRepository.getProfileSectionsData(callback);
    }
}
exports.GetProfileSectionsData = GetProfileSectionsData;
